const addQueryParamsToUrlString = (url, params) => {
    if (!params || Object.keys(params).length === 0) {
        return url;
    }
    const urlObj = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            urlObj.searchParams.append(key, value);
        }
    });
    return urlObj.toString();
};
const updateUrlWithLastValue = (url, paramKey, paramValue) => {
    const urlObj = new URL(url);
    urlObj.searchParams.delete(paramKey);
    urlObj.searchParams.append(paramKey, paramValue);
    return urlObj.toString();
};
export { addQueryParamsToUrlString, updateUrlWithLastValue };
//# sourceMappingURL=url.js.map